import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Clock } from "lucide-react";

export default function PendingApproval() {
  const { user, logout, refresh } = useAuth();
  return (
    <div className="min-h-screen bg-[#F7F5EF] flex items-center justify-center p-6">
      <Card className="w-full max-w-md p-6 sm:p-8 text-center" data-testid="pending-approval-page">
        <div className="mx-auto w-12 h-12 rounded-full bg-[#F4EFE1] flex items-center justify-center mb-4">
          <Clock className="w-6 h-6 text-[#6B5A1D]" />
        </div>
        <div className="text-[11px] uppercase tracking-[0.24em] text-[#C9A961] font-semibold">Access Request</div>
        <h1 className="font-serif text-2xl text-[#0A1F44] mt-1">Awaiting Admin approval</h1>
        <p className="text-sm text-slate-600 mt-3">
          Your Team Smith Hub access request has been submitted and is awaiting Admin approval.
        </p>
        <div className="mt-4 rounded-lg border border-slate-200 p-3 text-left text-xs text-slate-600 bg-white">
          <div><span className="text-slate-400">Name</span> <span className="font-medium text-slate-800">{user?.name}</span></div>
          <div><span className="text-slate-400">Email</span> <span className="font-medium text-slate-800">{user?.email}</span></div>
          <div><span className="text-slate-400">Team</span> <span className="font-medium text-slate-800">{user?.upline_team || "—"}</span></div>
        </div>
        <div className="flex items-center justify-center gap-2 mt-6">
          <Button variant="ghost" onClick={() => refresh()} data-testid="pending-refresh">Check again</Button>
          <Button onClick={logout} className="rounded-full bg-[#0A1F44] text-white" data-testid="pending-signout">Sign out</Button>
        </div>
      </Card>
    </div>
  );
}
